import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CheckLobAddressInput, LobAddress } from '@/models/address';

export const checkLobAddress = async ({
  streetAddress,
  streetAddress2,
  city,
  state,
  zip,
  country,
}: CheckLobAddressInput): Promise<LobAddress> => {
  const response = await queryExecute({
    query: graphql(`
      query CheckLobAddress(
        $streetAddress: String
        $streetAddress2: String
        $city: String
        $zip: String!
        $state: String
        $country: String
      ) {
        checkLobAddress(
          streetAddress: $streetAddress
          streetAddress2: $streetAddress2
          city: $city
          zip: $zip
          state: $state
          country: $country
        ) {
          deliverability
          message
          streetNumber
          streetName
          streetSuffix
          secondaryNumber
          secondaryDesignator
          city
          state
          zipCode
          zipCodePlus4
          addressType
          recordType
          country
          latitude
          longitude
        }
      }
    `),
    variables: {
      streetAddress,
      streetAddress2,
      city,
      zip,
      state,
      country,
    },
  });

  return response.data?.checkLobAddress;
};
